import uuid from 'uuid-random';

export const generateUuid = (): string => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (sessionId === null) {
    sessionId = uuid();
    sessionStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};
